import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./CustomModal.module.scss";

const CustomModal = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "sm",
  fullWidth = true,
  PaperProps = {},
  hideCloseIcon = false,
  titleSx = {},
  contentSx = {},
  actionsSx = {},
  dividers = false,
}) => {
  const paperClassName = [styles.paper, PaperProps?.className]
    .filter(Boolean)
    .join(" ");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        ...PaperProps,
        style: PaperProps?.style,
        className: paperClassName,
      }}
    >
      {title && (
        <DialogTitle
          className={styles.title}
          sx={titleSx}
        >
          {title}
          {!hideCloseIcon && onClose && (
            <IconButton
              onClick={onClose}
              size="small"
              className={styles.closeButton}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent dividers={dividers} sx={contentSx}>
        {children}
      </DialogContent>

      {actions && (
        <DialogActions className={styles.actions} sx={actionsSx}>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomModal;
